import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// --- Animación individual de slide ---
export function animateHeroSlide(slide) {
    if (!slide) return;

    const image = slide.querySelector(".hero__image");
    const title = slide.querySelector(".rdv-hero__content--title");
    const content = slide.querySelector(".rdv-hero__content");
    const button = slide.querySelector(".btn");
    const shape = slide.querySelector(".rdv-hero__shape");

    // Reset previo (importante para que la animación se repita)
    gsap.set([content].filter(Boolean), { y: 40, opacity: 0 });

    if (image) gsap.set(image, { scale: 1.1, opacity: 0 });

    // Animación de la imagen
    if (image) {
        gsap.to(image, {
            scale: 1,
            opacity: 1,
            duration: 1.8,
            ease: "bounce.out"
        });
    }

    // Animación del texto y botón
    const elemsToAnimate = [content].filter(Boolean);
    if (elemsToAnimate.length) {
        gsap.to(elemsToAnimate, {
            y: 0,
            opacity: 1,
            duration: 1.5,
            ease: "bounce.out",
            stagger: 0.1,
        });
    }

    // Animación del shape
    if (shape) {
        gsap.to(shape, {
            y: 10,
            duration: 3,
            ease: "power1.inOut",
            repeat: -1,
            yoyo: true,
        });
    }
}
